// Validación + envío del formulario de /soporte (SoporteNuevo), separados del
// componente para poder probarlos.
//
// Regla de producto: el portal anónimo (alta + seguimiento por ref/token) debe
// seguir funcionando. Compañía y usuario afectado sólo se exigen a quien tiene
// sesión; el alta anónima no los muestra, no los valida ni los envía (el backend
// los ignora y el agente los asigna al triar).
import {
  createMyTicket,
  createPublicTicket,
  type CreatePublicTicketInput,
  type CreateTicketResult,
} from "../../../Layouts/service-desk/services/serviceDeskService";

export type TicketFormError = "formRequired" | "companyRequired" | "affectedUserRequired";

export interface TicketFormRequiredFields {
  email: string;
  title: string;
  brand: string;
  companyId?: string;
  affectedUserId?: string;
}

export function validateTicketForm(
  form: TicketFormRequiredFields,
  { authenticated }: { authenticated: boolean },
): TicketFormError | null {
  if (!form.email || !form.title || !form.brand) return "formRequired";
  if (!authenticated) return null;
  if (!form.companyId) return "companyRequired";
  if (!form.affectedUserId) return "affectedUserRequired";
  return null;
}

export async function submitSupportTicket(
  input: CreatePublicTicketInput,
  { authenticated }: { authenticated: boolean },
): Promise<CreateTicketResult> {
  if (authenticated) {
    const ticket = await createMyTicket({
      ...input,
      companyId: input.companyId || "",
      affectedUserId: input.affectedUserId || "",
    });
    return { reference: ticket.reference, token: ticket.token || "", statusUrl: "", ticket };
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { companyId, affectedUserId, ...anonymous } = input;
  return createPublicTicket(anonymous);
}
